import { BACKEND_URL } from "@/lib/constants/constants";

import axios from "../custom/axiosConfig";

const internalAssistant = async (
  humanPrompt: string,
  systemPrompt = "",
  imageSearchQuery?: string,
) => {
  const response = await axios<{ response: string; images: string[] }>({
    //using the post method here to hide the prompt from the URL.
    method: "post",
    url: `${BACKEND_URL}/ai-assistant`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      humanPrompt,
      systemPrompt,
      imageSearchQuery,
    },
  });

  const returnedImages = response?.data?.images ?? [];

  return {
    summary: response?.data?.response as string,
    urls: [] as any,
    images: returnedImages,
  };
};

const wordwareAssistant = async (humanPrompt: string) => {
  const response = await axios<{
    response: {
      summary: string;
      urls: {
        url: {
          title: string;
          url: string;
        };
      };
    };
  }>({
    method: "post",
    url: `${BACKEND_URL}/ai-assistant/wordware`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      inputs: {
        supplier_name: `${humanPrompt}`,
      },
      version: "1.1.0",
      app: "f8da9b3a-5f33-4f17-ad8b-4f31d7c9b65d",
    },
  });

  return {
    summary: response.data.response.summary as string,
    urls: response.data.response.urls,
    images: [],
  };
};

export const promptAiAssistant = async (
  humanPrompt: string,
  systemPrompt?: string,
  imageSearchQuery?: string,
  type: "internal" | "wordware" = "internal",
) => {
  switch (type) {
    case "internal":
      return internalAssistant(humanPrompt, systemPrompt, imageSearchQuery);
    case "wordware":
      return wordwareAssistant(humanPrompt);
  }
};
